<template>
    <div class="order-content">
        <div class="teaching-content">
            <div class="teach-each">
                <template v-if="teachingGatherVo.image != null && teachingGatherVo.image != ''">
                    <img :src=teachingGatherVo.image class="teach-each-img" />
                </template>
                <template v-else>
                    <img src="../assets/image/teaching-img.png" class="teach-each-img" />
                </template>
                <div class="teach-info">
                    <div class="teach-name"> {{ teachingGatherVo.name }}</div>
                    <template v-if="teachingGatherVo.isOpen === '0'">
                        <div class="teach-price">免费</div>
                    </template>
                    <template v-else>
                        <div class="teach-price">¥ {{ teachingGatherVo.price }}</div>
                    </template>
                </div>
            </div>
            <div class="pay-way">
                <div class="pay-way-title">支付方式</div>
                <div class="pay-way-list">
                    <div class="pay-way-each left pay-wx" :class="{ 'select': payWay === '0' }"
                        @click="changePayWay('0')">
                    </div>
                    <div class="pay-way-each pay-zfb" :class="{ 'select': payWay === '1' }" @click="changePayWay('1')">
                    </div>
                </div>
            </div>
        </div>
        <div class="teaching-pay" v-if="teachingGatherVo.isOpen === '1' && teachingGatherVo.privilegeSource === '0'">
            <div class="teaching-pay-left">课程费用：¥ {{ teachingGatherVo.price }}</div>
            <div class="teaching-pay-right" @click="creatOrder">立即购买</div>
        </div>
    </div>
</template>
<script>
import { getTeachingGatherDetails, unionwxpay, getAlipayEntry, unionwxpayIn } from '@/api/common'
import wx from "weixin-js-sdk"
import { showToast } from 'vant';
export default {
    name: 'OrderPayPage',
    props: ['id'],
    data() {
        return {
            merchantId: '',
            teachingId: '',
            teachingGatherVo: {},
            payWay: '0',
            sourceStudentId: null,
            isInWx: false,
            wxCode: null
        }
    },
    created() {
        this.merchantId = this.id;
        this.teachingId = this.$route.query.teachingId;
        this.getDetails(this.merchantId);
        let memberId = sessionStorage.getItem('sourceStudentId') || null;
        if (memberId != '' && memberId != null) {
            this.sourceStudentId = memberId;
        }
        let broser = window.navigator.userAgent.toLowerCase();
        if (broser.match(/MicroMessenger/i) == 'micromessenger') {
            this.isInWx = true;
        }
        const code = this.getUrlParam("code")
        if (this.isInWx) {
            if (code != null && code != '') {
                this.wxCode = code;
            } else {
                this.getWxCode();
            }
        }
    },
    methods: {
        getWxCode() {
            let appId = 'wxea179edd8de30199';
            //重定向的地址,重定向回当前负面
            const local = window.location.href
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect';
        },
        getDetails() {
            let params = {
                id: this.teachingId
            };
            getTeachingGatherDetails(params).then((res) => {
                this.teachingGatherVo = res.teachingGatherVo;
            })
        },
        changePayWay(index) {
            this.payWay = index;
        },
        creatOrder() {
            if (this.payWay === '0') {
                if (this.isInWx) {
                    this.wxPayIn()
                } else {
                    this.wxPayOut()
                }
            } else if (this.payWay === '1') {
                if (this.isInWx) {
                    showToast("请在浏览器中打开");
                    return;
                }
                this.zfbPay()
            }
        },
        // 微信内支付
        wxPayIn() {
            let params = {
                id: this.teachingId,
            }
            if (this.sourceStudentId != null) {
                params.sourceStudentId = this.sourceStudentId;
            }
            if (this.wxCode === null || this.wxCode === '') {
               this.getWxCode();
               return;
            }
            params.code = this.wxCode;
            unionwxpayIn(params).then((res) => {
                if (res.code === 200 && this.isInWx) {
                    this.wxConfig(JSON.parse(res.result));
                } else {
                    showToast(res.msg);
                }
            })
        },
        // 微信外支付
        wxPayOut() {
            let params = {
                id: this.teachingId,
            }
            if (this.sourceStudentId != null) {
                params.sourceStudentId = this.sourceStudentId;
            }
            unionwxpay(params).then((res) => {
                if (res.code === 200) {
                    const name = '_self'
                    if (res.mwebUrl !== null) {
                        window.open(res.mwebUrl, name)
                    }
                } else {
                    showToast(res.msg);
                }
            })
        },
        zfbPay() {
            let params = {
                id: this.teachingId,
            }
            if (this.sourceStudentId != null) {
                params.sourceStudentId = this.sourceStudentId;
            }
            getAlipayEntry(params).then((res) => {
                if (res.code === 200) {
                    //将表单渲染进贝面
                    document.querySelector('body').innerHTML = res.url;
                    //在渲染完立即提交表单,就会进入支付宝支付的界面
                    this.$nextTick(() => {
                        window.document.forms[0].submit()
                    });
                } else {
                    showToast(res.msg);
                }
            })
        },
        getUrlParam(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
            let url = window.location.href
            let search = url.split('?')[1]
            if (search) {
                var r = search.substr(0).match(reg)
                if (r !== null) return unescape(r[2])
                return null
            } else
                return null
        },
        wxConfig(res) {
            // 调起微信支付
            let { appId, nonceStr, timeStamp, paySign, signType } = res;
            let prepayId = res.package;
            wx.config({
                debug: false, // 测试阶段可用 true 打包返回给后台用 false
                appId: appId,
                timestamp: timeStamp,
                nonceStr: nonceStr,
                signature: paySign,
                jsApiList: ['chooseWXPay']
            });
            let that = this;
            wx.ready(function () {
                wx.chooseWXPay({
                    appId: appId,
                    timestamp: timeStamp, // 时间戳
                    nonceStr: nonceStr, // 随机字符串
                    package: prepayId, // 统一支付接口返回的prepay_id参数值
                    signType: signType, //  签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                    paySign: paySign, // 支付签名
                    success: function () {
                        showToast('支付成功');
                        that.$router.push({
                            path: '/teaching/' + that.merchantId, query: {
                                teachingId: that.teachingId,
                            }
                        });
                    },
                    cancel: function () {
                        showToast('支付取消');
                    },
                    fail: function () {
                        showToast('支付失败');
                    }
                });
            });
        }
    }
}
</script>
<style scoped>
.order-content {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #f5f5f5;
    overflow: hidden;
}

.teaching-pay {
    display: flex;
    height: 44px;
    line-height: 44px;
    background-color: #fff;
}

.teaching-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.teaching-pay-left {
    flex: 1;
    padding: 0 20px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #333333;
    letter-spacing: 0;
    text-align: left;
    font-weight: 400;
    border-top: 1px solid #e5e5e5;
}

.teaching-pay-right {
    width: 144px;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #FFFFFF;
    letter-spacing: 0;
    font-weight: 400;
    background-color: red;
}

.teach-each {
    display: flex;
    padding: 20px 15px;
    margin-bottom: 8px;
    background-color: #fff;
}

.teach-each-img {
    margin-right: 10px;
    width: 142px;
    height: 90px;
    object-fit: cover;
    border-radius: 5px;
}

.teach-info {
    flex: 1;
    text-align: left;
    overflow: hidden;
}

.teach-name {
    margin-top: 5px;
    font-family: PingFangHK-Regular;
    font-size: 14px;
    line-height: 20px;
    color: #333333;
    font-weight: 400;
}

.teach-price {
    margin-top: 28px;
    text-align: right;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 500;
}

.pay-way {
    padding: 12px 15px 33px 15px;
    overflow: hidden;
    background-color: #fff;
}

.pay-way-title {
    margin-bottom: 14px;
    text-align: left;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
}

.pay-way-list {
    display: flex;
}

.pay-way-each {
    flex: 2;
    height: 0;
    padding-bottom: calc((50% - 19px /2) * 49 / 163);
    border: 1px solid transparent;
}

.pay-way-each.left {
    margin-right: 19px;
}

.pay-way-each.select {
    border: 1px solid #F11515;
}

.pay-wx {
    display: inline-block;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../assets/image/pay-wx.png');
}

.pay-zfb {
    display: inline-block;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../assets/image/pay-zfb.png');
}
</style>